import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {Form} from 'formik';
import classnames from 'classnames';
import LogoMain from '../../../../common/assets/logo/logo-h-black.svg';
import FieldInput from 'common/components/FieldInput';
import TooltipContainer from 'common/components/TooltipContainer';
import ErrorMessage from 'common/components/ErrorMessage/ErrorMessage';
import FieldSelect from '../../../../common/components/FieldSelect';
import PrivacyPolicyPopup
  from '../../../../common/components/PrivacyPolicyPopup';
import styles from './styles.module.scss';

const RegisterPageView = ({
                            values,
                            onLoginClick,
                            messageText,
                            showErrorMessage,
                            hideGlobalErrorMessage,
                            genderOptions,
                            onErrorMessageClose,
                          }) => {
  const [enableSubmit, setEnableSubmit] = useState(false);

  return (
    <div className={styles.register}>
      <div className={styles.window}>
        <div className={styles.registerLogoMain}>
          <img
            src={LogoMain}
            alt="large_bk"
          />
        </div>
        <Form>
          <div className={styles.row}>
            <FieldInput
              fieldId="email"
              type={'email'}
              value={values.email}
              label="שם משתמש (אימייל)"
              classNames={{
                input: styles.input,
                label: styles.inputLabel,
              }}
            />
          </div>
          <div className={styles.row}>
            <FieldInput
              fieldId="password"
              type={'password'}
              value={values.password}
              label={(
                <>
                  <span className={styles.labelMargin}>סיסמה</span>
                  <TooltipContainer
                    label={
                      <div>
                        <p>סיסמה צריכה להכיל לפחות 8 תוים</p>
                        <p>סיסמה חייבת להכיל ספרה, אות גדולה ואות קטנה</p>
                      </div>
                    }
                  />
                </>
              )}
              showBird={false}
              peepPassword={true}
              classNames={{
                input: styles.input,
                label: styles.inputLabel,
              }}
            />
          </div>
          <div className={styles.row}>
            <FieldInput
              fieldId="confirmPassword"
              type={'password'}
              value={values.confirmPassword}
              label={(
                <>
                  <span className={styles.labelMargin}>אימות סיסמה</span>
                  <TooltipContainer
                    label={
                      <div>
                        <p>סיסמה צריכה להכיל לפחות 8 תוים</p>
                        <p>סיסמה חייבת להכיל ספרה, אות גדולה ואות קטנה</p>
                      </div>
                    }
                    customIconClassName={styles.customTooltipIcon}
                  />
                </>
              )}
              showBird={false}
              peepPassword={true}
              classNames={{
                input: styles.input,
                label: styles.inputLabel,
              }}
            />
          </div>
          <div className={styles.row}>
            <FieldInput
              fieldId="name"
              value={values.name}
              label="שם פרטי"
              classNames={{
                container: styles.halfSize,
                input: styles.input,
                label: styles.inputLabel,
              }}
            />
            <FieldInput
              fieldId="family_name"
              value={values.family_name}
              label="שם משפחה"
              classNames={{
                container: styles.halfSize,
                input: styles.input,
                label: styles.inputLabel,
              }}
            />
          </div>
          <div className={styles.row}>
            <FieldInput
              fieldId="licence"
              value={values.licence}
              label="מספר רישיון שמאי"
              classNames={{
                container: styles.halfSize,
                input: styles.input,
                label: styles.inputLabel,
              }}
            />
            <FieldSelect
              fieldId="gender"
              placeholder="בחר"
              label="מגדר"
              options={genderOptions}
              containerStyles={classnames(styles.halfSize, styles.gender)}
            />
          </div>
          <div className={styles.terms}>
            <span className={styles.preTermsText}>לחץ לקריאת</span>
            <PrivacyPolicyPopup
              label="תנאי שימוש ומדיניות פרטיות"
              enableSubmit={enableSubmit}
              setEnableSubmit={setEnableSubmit}
            />
          </div>
          <button
            type="submit"
            className={styles.buttonSend}
            disabled={!enableSubmit}
          >
            <span>צור משתמש</span>
          </button>
          <div className={styles.alreadyRegistered}>כבר רשום?
            <span
              className={styles.onLoginClick}
              onClick={onLoginClick}
            >לחץ  כאן  להתחברות
                        </span>
          </div>
        </Form>
      </div>
      <ErrorMessage
        showErrorMessage={showErrorMessage}
        message={messageText}
        hideGlobalErrorMessage={hideGlobalErrorMessage}
        callback={onErrorMessageClose}
      />
    </div>
  );
};

RegisterPageView.propTypes = {
  values: PropTypes.object,
  onRegisterClick: PropTypes.func,
  onErrorMessageClose: PropTypes.func
};

export default RegisterPageView;
